import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/description-exit.ogg'
import _imports_1 from '@/assets/audio/description-exit.mp3'
import _imports_2 from '@/assets/audio/description-enter.ogg'
import _imports_3 from '@/assets/audio/description-enter.mp3'
import _imports_4 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-26c751e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "audioDescriptionOverlayExit",
  preload: "auto"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/ogg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mp3"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", { autoplay: "" }, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_2,
    type: "audio/ogg"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_3,
    type: "audio/mp3"
  })
], -1))
const _hoisted_6 = { class: "coloured-box" }
const _hoisted_7 = { class: "item-name" }
const _hoisted_8 = { class: "graphic-box" }
const _hoisted_9 = { class: "item-name item-type" }
const _hoisted_10 = { class: "item-icon" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "star-box margin-left" }
const _hoisted_13 = { class: "description margin-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", _hoisted_1, _hoisted_4, 512),
    _hoisted_5,
    _createElementVNode("div", {
      id: "item-description-overlay-bg",
      class: _normalizeClass({ bg: true, 'zoom-fade-in': _ctx.active, 'zoom-fade-out': !_ctx.active }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitOutsideCheck && _ctx.exitOutsideCheck(...args))),
      onAnimationend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'main-box': true, 'zoom-in': _ctx.active, 'zoom-out': !_ctx.active }),
        style: _normalizeStyle(_ctx.cssBox)
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.item.name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.item.type), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "item-icon-img",
              src: require(`@/assets/images/${_ctx.item.id}.webp`)
            }, null, 8, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.rarity, (i) => {
              return (_openBlock(), _createElementBlock("img", {
                key: i,
                class: "star",
                src: _imports_4
              }))
            }), 128))
          ])
        ]),
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.item.description), 1)
      ], 6)
    ], 34)
  ], 64))
}